import React, {useEffect, useMemo, useState} from "react";
import clsx from "clsx";

const merge = (a, b, predicate = (a, b) => a === b) => {
    const c = [...a]; // copy to avoid side effects
    // add all items from B to copy C if they're not already present
    b.forEach((bItem) => (c.some((cItem) => predicate(bItem, cItem)) ? null : c.push(bItem)))
    return c;
}

function selectWall(onSurfaceChange, current, selected) {
    // create the new selection array
    let newSelection = {};
    if(current === undefined) {
        newSelection = { walls : selected }
    } else {
        let existSelection = false;
        if(selected.length == 1) {
            for (let i = 0; i < current.length; i++) {
                if (current[i] == selected[0]) {
                    current.splice(i, 1);
                    existSelection=true;
                }
            }
        }
        if(!existSelection) newSelection = { walls : merge(current, selected) }
        else newSelection = { walls : current }
    }
    // update active selectors
    document.querySelectorAll('.wallSelector').forEach(i => i.classList.remove('btn-info'));
    for(let i=0; i<newSelection.walls.length; i++) {
        document.querySelector('.wallSelector[data-wall-id="'+newSelection.walls[i]+'"]').classList.add("btn-info");
    }
    // send to parent
    onSurfaceChange(newSelection);
}

export default function RoomActions({wallSelectors, showSelectors, selectedSurfaces, startWithActiveProduct, onSurfaceChange}) {

    useEffect(() => {
        if(startWithActiveProduct) selectWall(onSurfaceChange, selectedSurfaces.walls, [...wallSelectors.keys()]);
    }, [startWithActiveProduct])

    /** Generate wall selectors elements
     *
     */
    const walls = useMemo(() => {
        let isSelected = [];
        for(let i=0; i<wallSelectors.length; i++) {
            let n = 0;
            if(selectedSurfaces.walls != undefined) n = selectedSurfaces.walls.length;
            for(let j=0; j<n; j++) {
                if(selectedSurfaces.walls[j] == i) {
                    isSelected[i] = true;
                    break;
                }
            }
            if(isSelected[i] === undefined) isSelected[i] = false;
        }

        const walls = wallSelectors.map((node, i) =>
            ([
                <button
                    key={i}
                    data-wall-id={i}
                    className={
                        clsx(
                            'btn btn-sm btn-icon shadow roomAction wallSelector',
                            {'btn-light': !isSelected[i]},
                            {'btn-info': isSelected[i]},
                        )
                    }
                    style={{
                        left: node[0]*100 + '%',
                        top: node[1]*100 + '%',
                    }}
                    onClick={() => selectWall(onSurfaceChange, selectedSurfaces.walls, [i])}
                >
                    <i className="ki-duotone ki-mouse-square fs-1">
                        <span className="path1"></span>
                        <span className="path2"></span>
                    </i>
                </button>
            ])
        )
        return walls;
    }, [wallSelectors, selectedSurfaces]);

    return <div id="roomActions">
        { showSelectors && wallSelectors.length > 1 &&
            [
                <button
                    key={1}
                    className="btn btn-sm shadow btn-light roomAction"
                    style={{
                        left: wallSelectors[0][0] * 100 + '%',
                        top: 'calc(' + (wallSelectors[0][1] * 100) + '% - 40px)',
                    }}
                    onClick={() => selectWall(onSurfaceChange, selectedSurfaces.walls, [...wallSelectors.keys()])}
                >
                    <i className="ki-duotone ki-mouse-square fs-3">
                        <span className="path1"></span>
                        <span className="path2"></span>
                    </i>
                    Select All Walls
                </button>
            ]
        }
        {showSelectors && walls}
    </div>
}